import { ElementRef } from '@angular/core';
import { createAction, props } from '@ngrx/store'
import { CurrencyType, Language } from 'app/shared/model/enums';


export const setLanguage = createAction('[Common Service] setLanguage', props<{ language: Language }>());
export const setCurrency = createAction('[Common Service] setCurrency', props<{ currency: CurrencyType }>());
export const setIsLoading = createAction('[Common Service] setIsLoading', props<{ isLoading: boolean, divElement: ElementRef }>());
export const setDivElement = createAction('[Common Service] setDivElement', props<{ divElement: any }>());
export const setDisplayLoginDialog = createAction('[Common Service] setDisplayLoginDialog', props<{ displayLoginDialog: boolean }>());
export const setBlockDocument = createAction('[Common Service] setBlockDocument', props<{ blockDocument: boolean }>());
export const setCurrentPageTitle = createAction('[Common Service] setCurrentPageTitle', props<{ displayPageTitle: boolean, pageTitle?: string }>());
